import * as React from "react";
import { observer } from "mobx-react-lite";
import { Checkbox } from "antd";
import { ZUid } from "src/types/zUid";
import { isChecked } from "src/common/groupChecked";
import { Bom3PositionStore } from "../Bom3PositionsStore";

type PropsHead = {
  store: Bom3PositionStore;
};
export const Bom3PositionSelectHead: React.FC<PropsHead> = observer(
  ({ store }) => (
    <Checkbox
      checked={isChecked(store.selectedAll)}
      indeterminate={store.selectedAll === "partial"}
      onChange={() => {
        store.toggleSelectAll();
      }}
    />
  ),
);

type PropsMaterial = {
  store: Bom3PositionStore;
  materialId: ZUid;
};
export const Bom3PoitionSelectMaterial: React.FC<PropsMaterial> = observer(
  ({ store, materialId }) => {
    const value = store.selectedMaterials[materialId];
    return (
      <Checkbox
        checked={isChecked(value)}
        indeterminate={value === "partial"}
        onChange={() => {
          store.toggleMaterialById(materialId);
        }}
        disabled={!value}
      />
    );
  },
);

type PropsRow = {
  store: Bom3PositionStore;
  rowId: ZUid;
};
export const Bom3PositionSelectRow: React.FC<PropsRow> = observer(
  ({ store, rowId }) => (
    <Checkbox
      checked={store.selectedRows.has(rowId)}
      onChange={() => store.toggleRowSelect(rowId)}
    />
  ),
);
